import { render } from "./AOE_EdPlan.vue?vue&type=template&id=b2a7560a"
import script from "./AOE_EdPlan.vue?vue&type=script&lang=js"
export * from "./AOE_EdPlan.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__